import { Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import ForgetPassword from "./pages/ForgetPassword";
import ResetPassword from "./pages/ResetPassword";

import Profile from "./pages/Profile";
import EditProfile from "./pages/EditProfile";
import ChangePassword from "./pages/ChangePassword";
import Otp from "./pages/Otp";
import EmailSentConfrimation from "./pages/EmailSentConfrimation";
import ConsultationView from "./pages/Consultation/ConsultationView";
import PatientRecord from "./pages/PatientRecord/PatientRecord";
import PatientRecordDetails from "./pages/PatientRecord/PatientRecordDetails";
import DiagnosticSuggestions from "./pages/DiagnosticSuggestions/DiagnosticSuggestions";
import DiagnosticSuggestionsView from "./pages/DiagnosticSuggestions/DiagnosticSuggestionsView";
import DiagnosticSuggestionsPending from "./pages/DiagnosticSuggestions/DiagnosticSuggestionsPending";
import ReferralManagement from "./pages/ReferralManagement/ReferralManagement";
import ReferralManagementView from "./pages/ReferralManagement/ReferralManagementView";
import ProtectedRoutes from "./components/ProtectedRoutes";
import DoctorManagement from "./pages/DoctorManage/DoctorManagement";
import AddDoctor from "./pages/DoctorManage/AddDoctor";
import ViewDoctor from "./pages/DoctorManage/ViewDoctor";
import DiagnosticsCenterManagement from "./pages/DiagnosticCenterManagement/DiagnosticsCenterManagement";
import AddDiagnosticCenter from "./pages/DiagnosticCenterManagement/AddDiagnosticCenter";
import DiagnosticsTestManagement from "./pages/DiagnosticsTestManagement/DiagnosticsTestManagement";
import AddDiagnosticTest from "./pages/DiagnosticsTestManagement/AddDiagnosticTest";
import ViewDiagnosticCenter from "./pages/DiagnosticCenterManagement/ViewDiagnosticCenter";
import ViewDiagnosticTest from "./pages/DiagnosticsTestManagement/ViewDiagnosticTest";
import Prescription from "./pages/Presciption/Prescription";
import CallHistory from "./pages/CallHistory/CallHistory";
import CallRate from "./pages/CallRate/CallRate";
import Dashboard from "./pages/Dashboard/Dashboard";
import ConsutlationLog from "./pages/Consultation/ConsutlationLog";
import CmsManagement from "./pages/CmsManagement";

function RoutesComponent() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />,
      <Route path="/forgotpassword" element={<ForgetPassword />} />,
      <Route path="/resetpassword" element={<ResetPassword />} />,
      <Route path="/change-password" element={<ChangePassword />} />,
      <Route path="/email-sent-confrimation" element={<EmailSentConfrimation />} />
      <Route path="/otp" element={<Otp />} />,
      <Route element={<ProtectedRoutes />}>
        children:[
        <Route path="/consultation-view" element={<ConsultationView />} />
        <Route path="/consultation-logs" element={<ConsutlationLog />} />
        <Route path="/patient-record" element={<PatientRecord />} />
        <Route path="/patient-record-details" element={<PatientRecordDetails />} />
        <Route path="/diagnostic-suggestions" element={<DiagnosticSuggestions />} />
        <Route path="/diagnostic-suggestions-view" element={<DiagnosticSuggestionsView />} />
        <Route path="/diagnostic-suggestions-pending" element={<DiagnosticSuggestionsPending />} />
        <Route path="/referral-management" element={<ReferralManagement />} />
        <Route path="/referral-management-view" element={<ReferralManagementView />} />
        <Route path="/doctor-management" element={<DoctorManagement />} />
        <Route path="/add-doctor" element={<AddDoctor />} />
        <Route path="/view-doctor" element={<ViewDoctor />} />

        <Route path="/diagnostic-center-management" element={<DiagnosticsCenterManagement />} />
        <Route path="/add-diagnostic-center" element={<AddDiagnosticCenter />} />
        <Route path="/view-diagnostic-center" element={<ViewDiagnosticCenter />} />

        <Route path="/diagnostic-test-management" element={<DiagnosticsTestManagement />} />
        <Route path="/add-diagnostic-test" element={<AddDiagnosticTest />} />
        <Route path="/view-diagnostic-test" element={<ViewDiagnosticTest />} />

        <Route path="/profile" element={<Profile />} />
        <Route path="/edit-profile" element={<EditProfile />} />

        <Route path="/prescribe-medicine" element={<Prescription />} />
        <Route path="/call-history" element={<CallHistory />} />
        <Route path="/call-rates" element={<CallRate />} />
        <Route path="/cms" element={<CmsManagement />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/" element={<Dashboard />} />
        ]
      </Route>
    </Routes>
  );
}


export default RoutesComponent;
